<script>
import Constants from '../constants';

import moveTextHover from '@/components/moveTextHover';
import shareBtn from '@/components/shareBtn';
import snsIcons from '@/components/snsIcons';

export default {
  name: 'commonFooter',
  components: {
    moveTextHover,
    shareBtn,
    snsIcons,
  },
  props: {
  },
  data() {
    return {
      copyRight: '',
      windowHeight: Constants.WINDOW.MIN_HEIGHT.viewSm,
    };
  },
  created() {
    this.copyRight = this.$t('message.copyRight', {
      thisYear: new Date().getFullYear(),
    });
    window.onresize = () => { this.onresize(); }
    this.onresize();
  },
  methods: {
    moveToIndex() {
      if (this.$router.currentRoute.name !== Constants.ROUTER.INDEX) {
        this.$router.push({
          name: Constants.ROUTER.INDEX,
        });
      } else {
        this.scrollToTop();
      }
    },
    moveToInformation() {
      if (this.$router.currentRoute.name !== Constants.ROUTER.INDEX) {
        this.$router.push({
          name: Constants.ROUTER.INDEX,
          query: {
            isInformation: 1,
          },
        });
      } else {
        this.scrollToTop(this.windowHeight);
      }
    },
    moveToBiography() {
      if (this.$router.currentRoute.name !== Constants.ROUTER.BIOGRAPHY) {
        this.$router.push({ name: Constants.ROUTER.BIOGRAPHY });
      } else {
        this.scrollToTop();
      }
    },
    moveToDiscography() {
      if (this.$router.currentRoute.name !== Constants.ROUTER.DISCOGRAPHY) {
        this.$router.push({ name: Constants.ROUTER.DISCOGRAPHY });
      } else {
        this.scrollToTop();
      }
    },
    moveToAboutSite() {
      if (this.$router.currentRoute.name !== Constants.ROUTER.ABOUTSITE) {
        this.$router.push({ name: Constants.ROUTER.ABOUTSITE });
      } else {
        this.scrollToTop();
      }
    },
    scrollToTop(scroll = 0) {
      window.scroll({
        top: scroll ,
        left: 0 ,
        behavior: "smooth" ,
      });
    },
    setLanguageEn() {
      if (this.$i18n.locale === Constants.LOCALE.EN) {
        return;
      }
      this.$i18n.locale = Constants.LOCALE.EN;
      sessionStorage.setItem(Constants.LOCALE.SESSION_STORAGE_KEY, this.$i18n.locale);
      if (this.$router.currentRoute.path === '/') {
        this.$router.go({path: '/', force: true});
      } else {
        this.moveToIndex();
      }
    },
    setLanguageJa() {
      if (this.$i18n.locale === Constants.LOCALE.JA) {
        return;
      }
      this.$i18n.locale = Constants.LOCALE.JA;
      sessionStorage.setItem(Constants.LOCALE.SESSION_STORAGE_KEY, this.$i18n.locale);
      if (this.$router.currentRoute.path === '/') {
        this.$router.go({path: '/', force: true});
      } else {
        this.moveToIndex();
      }
    },

    onresize() {
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      this.windowHeight = window.innerHeight < minHeight ? minHeight : window.innerHeight;
    },
  },
};
</script>

<template>
  <div class="common-footer" :class="$mq">
    <footer>
      <div class="share-container">
        <share-btn/>
      </div>

      <snsIcons />

      <div class="logo-container">
        <div class="logo" @click="moveToIndex" :title="$t('message.information.pageName')"></div>
      </div>

      <nav class="nav-container wf-gothicfont">
        <div class="is-link" @click="moveToInformation">
          <move-text-hover :target-text="$t('message.information.pageName')" />
        </div>
        <div class="is-link" @click="moveToDiscography">
          <move-text-hover :target-text="$t('message.discography.pageName')" />
        </div>
        <div class="is-link" @click="moveToBiography">
          <move-text-hover :target-text="$t('message.biography.pageName')" />
        </div>
      </nav>

      <div class="language-container">
        <div class="lang" @click="setLanguageJa">
          <move-text-hover :target-text="$t('message.language.ja')" />
        </div>
        <div class="lang" @click="setLanguageEn">
          <move-text-hover :target-text="$t('message.language.en')" />
        </div>
      </div>
      <div class="about-site-container">
        <div @click="moveToAboutSite">
          <move-text-hover :target-text="$t('message.aboutSite.pageName')" />
        </div>
      </div>
      <div class="copy-right">{{copyRight}}</div>
    </footer>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .common-footer {
    position: relative;
    z-index: $zIndexCommonFooter;
    width: 100%;
    text-align: center;
    background: $textColor;
    color: $bgColor;
    background: url(../assets/img/decoration/footer01.svg) left bottom,
      url(../assets/img/decoration/footer02.svg) right bottom,
      $textColor;
    @include bg;
    footer {
      height: 100%;
      display:flex;
      flex-flow: column;
      justify-content:space-between;

      .logo-container {
        .logo {
          cursor: pointer;
          background-image: url(../assets/img/common/bandLogoSquare.svg);
          @include bgCenter;
          margin: 0 auto;
          transition: 0.1s ease-out;
          &:hover {
            transform: scale(1.1);
          }
        }
      }

      .nav-container {
        .is-link {
          &:hover {
            color: $accentColor2;
          }
        }
      }

      .language-container {
        display: flex;
        justify-content: center;
        .lang {
          margin: 0 20px;
          cursor: pointer;
          &:hover {
            color: $accentColor2;
          }
        }
      }
      .about-site-container {
        display: flex;
        justify-content: center;
        font-size: 0.8em;
      }
      .copy-right {
        width: 100%;
        font-size: 0.8em;
      }
    }

    // responsible -----------------------------------------------
    &.viewLg {
      height: 400px;
      padding-top: 50px;
      footer {
        .share-container {
          position: absolute;
          bottom: 30px;
          right: 30px;
        }
        .logo-container {
          .logo {
            height: 150px;
            width: 150px;
          }
        }
        .nav-container {
          display: flex;
          justify-content: center;
          .is-link {
            margin: 0 20px;
            font-size: 1.5em;
          }
        }
      }
    }
    &.viewMd {
      height: 400px;
      footer {
        .logo-container {
          .logo {
            height: 140px;
            width: 140px;
          }
        }
        .nav-container {
          display: flex;
          justify-content: center;
          .is-link {
            margin: 0 15px;
            font-size: 1.3em;
          }
        }
      }
    }
    &.viewSm {
      padding-bottom: 50px;
      footer {
        .share-container {
          display: none;
        }
        .logo-container {
          .logo {
            height: 100px;
            width: 100px;
          }
        }
        .nav-container {
          .is-link {
            margin: 0 7px;
            font-size: 1.2em;
          }
        }
      }
    }
  }
</style>
